import { useTranslation } from 'react-i18next'

import { GapBox } from 'components/Box'
import { SectionHeader } from 'components/Header'
import Paper from 'components/Paper'
import { usePagination } from 'components/Table'
import { calculatePagination } from 'providers/tanstack-query/utils'
import { Context } from './Context'
import { FormContainer } from './form/FormContainer'
import { useGetAuditLogs } from './hooks/useGetAuditLogs'

import type { PaginationProps } from 'components/Table/Pagination'

export const ActivityLogPage = (): JSX.Element => {
  const { t } = useTranslation('features/history', { keyPrefix: 'activityLog' })
  const { page, rowsPerPage, setPage, setRowsPerPage } = usePagination()
  const { auditLogs, count, loading } = useGetAuditLogs({
    ...calculatePagination({ page, rowsPerPage }),
  })

  const paginationProps: PaginationProps = {
    count,
    page,
    rowsPerPage,
    setPage,
    setRowsPerPage,
  }

  return (
    <Paper>
      <SectionHeader
        subtitle={t('description')}
        title={t('title')}
      />

      <GapBox />

      <Context.Provider
        value={{
          auditLogs,
          loading,
          pagination: paginationProps,
        }}
      >
        <FormContainer />
      </Context.Provider>
    </Paper>
  )
}
